exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SMBGDateLineAnimated--smbgPath--W8OdK{fill:none;stroke:var(--trends--dark);stroke-dasharray:4,4}.SMBGDateLineAnimated--highlightPath--1aPEd{stroke-width:2px;stroke-dasharray:4,0}", ""]);

// exports
exports.locals = {
	"smbgPath": "SMBGDateLineAnimated--smbgPath--W8OdK",
	"highlightPath": "SMBGDateLineAnimated--highlightPath--1aPEd"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/smbg/SMBGDateLineAnimated.css
 ** module id = 151
 ** module chunks = 0
 **/